module.exports = __webpack_public_path__ + "media/flags/fr-6c3ca007.svg";